// AUTO-GENERATED by mercato generate entity-ids
export const M = {
  "dashboards": "dashboards",
  "auth": "auth",
  "directory": "directory",
  "customers": "customers",
  "perspectives": "perspectives",
  "entities": "entities",
  "configs": "configs",
  "query_index": "query_index",
  "audit_logs": "audit_logs",
  "attachments": "attachments",
  "catalog": "catalog",
  "sales": "sales",
  "api_keys": "api_keys",
  "dictionaries": "dictionaries",
  "api_docs": "api_docs",
  "business_rules": "business_rules",
  "feature_toggles": "feature_toggles",
  "workflows": "workflows",
  "currencies": "currencies",
  "planner": "planner",
  "resources": "resources",
  "staff": "staff",
  "notifications": "notifications",
  "progress": "progress",
  "integrations": "integrations",
  "data_sync": "data_sync",
  "messages": "messages",
  "translations": "translations",
  "inbox_ops": "inbox_ops",
  "payment_gateways": "payment_gateways",
  "shipping_carriers": "shipping_carriers",
  "customer_accounts": "customer_accounts",
  "portal": "portal"
} as const
export const E = {
  "dashboards": {
    "dashboard_layout": "dashboards:dashboard_layout",
    "dashboard_role_widgets": "dashboards:dashboard_role_widgets",
    "dashboard_user_widgets": "dashboards:dashboard_user_widgets"
  },
  "auth": {
    "user": "auth:user",
    "role": "auth:role",
    "user_sidebar_preference": "auth:user_sidebar_preference",
    "role_sidebar_preference": "auth:role_sidebar_preference",
    "user_role": "auth:user_role",
    "session": "auth:session",
    "password_reset": "auth:password_reset",
    "role_acl": "auth:role_acl",
    "user_acl": "auth:user_acl"
  },
  "directory": {
    "tenant": "directory:tenant",
    "organization": "directory:organization"
  },
  "customers": {
    "customer_entity": "customers:customer_entity",
    "customer_person_profile": "customers:customer_person_profile",
    "customer_company_profile": "customers:customer_company_profile",
    "customer_deal": "customers:customer_deal",
    "customer_deal_person_link": "customers:customer_deal_person_link",
    "customer_deal_company_link": "customers:customer_deal_company_link",
    "customer_activity": "customers:customer_activity",
    "customer_comment": "customers:customer_comment",
    "customer_address": "customers:customer_address",
    "customer_settings": "customers:customer_settings",
    "customer_tag": "customers:customer_tag",
    "customer_tag_assignment": "customers:customer_tag_assignment",
    "customer_dictionary_entry": "customers:customer_dictionary_entry",
    "customer_pipeline": "customers:customer_pipeline",
    "customer_pipeline_stage": "customers:customer_pipeline_stage",
    "customer_todo_link": "customers:customer_todo_link"
  },
  "perspectives": {
    "perspective": "perspectives:perspective",
    "role_perspective": "perspectives:role_perspective"
  },
  "entities": {
    "custom_field_def": "entities:custom_field_def",
    "custom_field_entity_config": "entities:custom_field_entity_config",
    "custom_entity": "entities:custom_entity",
    "custom_entity_storage": "entities:custom_entity_storage",
    "custom_field_value": "entities:custom_field_value",
    "encryption_map": "entities:encryption_map"
  },
  "configs": {
    "module_config": "configs:module_config",
    "upgrade_action_run": "configs:upgrade_action_run"
  },
  "query_index": {
    "entity_index_row": "query_index:entity_index_row",
    "entity_index_job": "query_index:entity_index_job",
    "entity_index_coverage": "query_index:entity_index_coverage",
    "indexer_error_log": "query_index:indexer_error_log",
    "indexer_status_log": "query_index:indexer_status_log",
    "search_token": "query_index:search_token"
  },
  "audit_logs": {
    "action_log": "audit_logs:action_log",
    "access_log": "audit_logs:access_log"
  },
  "attachments": {
    "attachment_partition": "attachments:attachment_partition",
    "attachment": "attachments:attachment"
  },
  "catalog": {
    "catalog_option_schema_template": "catalog:catalog_option_schema_template",
    "catalog_product": "catalog:catalog_product",
    "catalog_product_unit_conversion": "catalog:catalog_product_unit_conversion",
    "catalog_product_category": "catalog:catalog_product_category",
    "catalog_product_category_assignment": "catalog:catalog_product_category_assignment",
    "catalog_product_tag": "catalog:catalog_product_tag",
    "catalog_product_tag_assignment": "catalog:catalog_product_tag_assignment",
    "catalog_offer": "catalog:catalog_offer",
    "catalog_product_variant": "catalog:catalog_product_variant",
    "catalog_product_variant_relation": "catalog:catalog_product_variant_relation",
    "catalog_price_kind": "catalog:catalog_price_kind",
    "catalog_product_price": "catalog:catalog_product_price"
  },
  "sales": {
    "sales_channel": "sales:sales_channel",
    "sales_shipping_method": "sales:sales_shipping_method",
    "sales_delivery_window": "sales:sales_delivery_window",
    "sales_payment_method": "sales:sales_payment_method",
    "sales_tax_rate": "sales:sales_tax_rate",
    "sales_order": "sales:sales_order",
    "sales_order_line": "sales:sales_order_line",
    "sales_order_adjustment": "sales:sales_order_adjustment",
    "sales_settings": "sales:sales_settings",
    "sales_document_sequence": "sales:sales_document_sequence",
    "sales_quote": "sales:sales_quote",
    "sales_quote_line": "sales:sales_quote_line",
    "sales_quote_adjustment": "sales:sales_quote_adjustment",
    "sales_shipment": "sales:sales_shipment",
    "sales_shipment_item": "sales:sales_shipment_item",
    "sales_return": "sales:sales_return",
    "sales_return_line": "sales:sales_return_line",
    "sales_invoice": "sales:sales_invoice",
    "sales_invoice_line": "sales:sales_invoice_line",
    "sales_credit_memo": "sales:sales_credit_memo",
    "sales_credit_memo_line": "sales:sales_credit_memo_line",
    "sales_payment": "sales:sales_payment",
    "sales_payment_allocation": "sales:sales_payment_allocation",
    "sales_note": "sales:sales_note",
    "sales_document_address": "sales:sales_document_address",
    "sales_document_tag": "sales:sales_document_tag",
    "sales_document_tag_assignment": "sales:sales_document_tag_assignment"
  },
  "api_keys": {
    "api_key": "api_keys:api_key"
  },
  "dictionaries": {
    "dictionary": "dictionaries:dictionary",
    "dictionary_entry": "dictionaries:dictionary_entry"
  },
  "business_rules": {
    "business_rule": "business_rules:business_rule",
    "rule_execution_log": "business_rules:rule_execution_log",
    "rule_set": "business_rules:rule_set",
    "rule_set_member": "business_rules:rule_set_member"
  },
  "feature_toggles": {
    "feature_toggle": "feature_toggles:feature_toggle",
    "feature_toggle_override": "feature_toggles:feature_toggle_override"
  },
  "workflows": {
    "workflow_definition": "workflows:workflow_definition",
    "workflow_instance": "workflows:workflow_instance",
    "step_instance": "workflows:step_instance",
    "user_task": "workflows:user_task",
    "workflow_event": "workflows:workflow_event",
    "workflow_event_trigger": "workflows:workflow_event_trigger"
  },
  "currencies": {
    "currency": "currencies:currency",
    "exchange_rate": "currencies:exchange_rate",
    "currency_fetch_config": "currencies:currency_fetch_config"
  },
  "planner": {
    "planner_availability_rule_set": "planner:planner_availability_rule_set",
    "planner_availability_rule": "planner:planner_availability_rule"
  },
  "resources": {
    "resources_resource_type": "resources:resources_resource_type",
    "resources_resource": "resources:resources_resource",
    "resources_resource_comment": "resources:resources_resource_comment",
    "resources_resource_activity": "resources:resources_resource_activity",
    "resources_resource_tag": "resources:resources_resource_tag",
    "resources_resource_tag_assignment": "resources:resources_resource_tag_assignment"
  },
  "staff": {
    "staff_team": "staff:staff_team",
    "staff_team_role": "staff:staff_team_role",
    "staff_team_member": "staff:staff_team_member",
    "staff_leave_request": "staff:staff_leave_request",
    "staff_team_member_comment": "staff:staff_team_member_comment",
    "staff_team_member_activity": "staff:staff_team_member_activity",
    "staff_team_member_job_history": "staff:staff_team_member_job_history",
    "staff_team_member_address": "staff:staff_team_member_address"
  },
  "notifications": {
    "notification": "notifications:notification"
  },
  "progress": {
    "progress_job": "progress:progress_job"
  },
  "integrations": {
    "sync_external_id_mapping": "integrations:sync_external_id_mapping",
    "integration_credentials": "integrations:integration_credentials",
    "integration_state": "integrations:integration_state",
    "integration_log": "integrations:integration_log"
  },
  "data_sync": {
    "sync_run": "data_sync:sync_run",
    "sync_cursor": "data_sync:sync_cursor",
    "sync_mapping": "data_sync:sync_mapping",
    "sync_schedule": "data_sync:sync_schedule"
  },
  "messages": {
    "message": "messages:message",
    "message_recipient": "messages:message_recipient",
    "message_object": "messages:message_object",
    "message_access_token": "messages:message_access_token",
    "message_confirmation": "messages:message_confirmation"
  },
  "translations": {
    "entity_translation": "translations:entity_translation"
  },
  "inbox_ops": {
    "inbox_settings": "inbox_ops:inbox_settings",
    "inbox_email": "inbox_ops:inbox_email",
    "inbox_proposal": "inbox_ops:inbox_proposal",
    "inbox_proposal_action": "inbox_ops:inbox_proposal_action",
    "inbox_discrepancy": "inbox_ops:inbox_discrepancy"
  },
  "payment_gateways": {
    "gateway_transaction": "payment_gateways:gateway_transaction",
    "webhook_processed_event": "payment_gateways:webhook_processed_event"
  },
  "shipping_carriers": {
    "carrier_shipment": "shipping_carriers:carrier_shipment"
  },
  "customer_accounts": {
    "customer_user": "customer_accounts:customer_user",
    "customer_role": "customer_accounts:customer_role",
    "customer_role_acl": "customer_accounts:customer_role_acl",
    "customer_user_role": "customer_accounts:customer_user_role",
    "customer_user_acl": "customer_accounts:customer_user_acl",
    "customer_user_session": "customer_accounts:customer_user_session",
    "customer_user_email_verification": "customer_accounts:customer_user_email_verification",
    "customer_user_password_reset": "customer_accounts:customer_user_password_reset",
    "customer_user_invitation": "customer_accounts:customer_user_invitation"
  }
} as const
export type KnownModuleId = keyof typeof M
export type KnownEntities = typeof E
